import { render, staticRenderFns } from "./CityModal.vue?vue&type=template&id=52be1d4e&scoped=true"
import script from "./CityModal.vue?vue&type=script&lang=js"
export * from "./CityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be1d4e",
  null
  
)

export default component.exports